import { createContext } from 'react';
import type { PricingTier } from '~/types/Journey.types';

export type FuturePricingTiers = {
  blueprintId: string;
  cheapestAvailableDate: string | null;
  cheapestAvailableDateUpdated: string | null;
  pricingTiers: PricingTier[];
} | null;

export type UnavailableDates = {
  blueprintId: string;
  dates: string[] | null;
} | null;

type JourneyDataContextType = {
  user: null | any;
  journeyType: null | string;
  urlPath: null | string;
  futurePricingTiers?: FuturePricingTiers | null;
  unavailableDates?: UnavailableDates | null;
  loyaltyDiscount?: number;
  loyaltyTierId?: string;
  loyaltyTierName?: string;
};

const JourneyDataContext = createContext<JourneyDataContextType>({
  user: null,
  journeyType: null,
  urlPath: null,
  futurePricingTiers: null,
  unavailableDates: null,
  loyaltyDiscount: 0,
  loyaltyTierId: undefined,
  loyaltyTierName: undefined
});

export default JourneyDataContext;
